import React,{ useEffect } from 'react';
import { useParams } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import PinUpdateForm from '../../components/forms/PinUpdateForm/PinUpdateForm';

const PinUpdate = () => {

  const { uid } = useParams();

  return (
    <AuthLayout pageName="pinupdate">
      <PinUpdateForm userId={uid} />
    </AuthLayout>
  );
};

export default PinUpdate;
